import { useRouter } from 'next/router';
import { SingleAddress } from '@zoocasa/go-search';
import HeadData from 'components/head-data';
import Layout from 'components/layout';
import { createAddressesApi, parsedAddressPathFromJson } from 'data/addresses';
import { createInsightsApi } from 'data/insights';
import { DynamicPageServerSideProps } from 'types';
import {
  createGetServerSideProps,
  HandlerType,
} from 'utils/next/shared-getServerSideProps';
import {
  CityInfoPage,
  CityInfoPageServerSideProps,
  CityInfoPageViewModel,
  getCityInfoPageServerSideProps,
} from 'components/pages/city-info';

const handler: HandlerType<serverSidePropsType> = async (context, features, tenant) => {
  const addressesApi = createAddressesApi();
  const insightsApi = createInsightsApi();
  return await getCityInfoPageServerSideProps(context, features, tenant, addressesApi, insightsApi);
};

export const getServerSideProps = createGetServerSideProps(handler);

type serverSidePropsType = DynamicPageServerSideProps<CityInfoPageServerSideProps>;

export default function CityInfoPageRoute({ routeName, props }: serverSidePropsType) {
  const router = useRouter();

  const {
    requestedAddress: requestedAddressData,
    electedAddress: electedAddressData,
    ...viewModelData
  } = props as CityInfoPageViewModel;

  const requestedAddress = parsedAddressPathFromJson(requestedAddressData);
  const electedAddress = SingleAddress.fromJSON(electedAddressData);

  const viewModel: CityInfoPageViewModel = {
    requestedAddress,
    electedAddress,
    ...viewModelData,
  };

  // Use router.asPath as key to force component remount when URL changes
  const pageKey = router.isReady ? router.asPath : router.pathname;

  return (
    <Layout routeName={routeName}>
      {props.headTags && <HeadData data={props.headTags} />}
      <CityInfoPage key={pageKey} viewModel={viewModel} />
    </Layout>
  );
}
